import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export namespace DoppeActionTypeSocialIcon {
    export interface ActionSettings {
    }
}

export const doppeActionTypeSocialIcon = doppeActionTypeDefineMetadata<DoppeActionTypeSocialIcon.ActionSettings>({
    id: 'io.bymo.action/social-icon',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({}),
    canRenderInPage: false,
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false
});